import { render, staticRenderFns } from "./InviteMember.vue?vue&type=template&id=1f1ba8d8&"
import script from "./InviteMember.vue?vue&type=script&lang=js&"
export * from "./InviteMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports